<template>
    <div class="secpol">
        <v-layout column align-center>
            <v-flex xs12>
                <v-card style="max-width: 860px;">
                    <v-toolbar flat dark color="primary">
                        <v-toolbar-title>
                            <v-icon>security</v-icon>
                            Политика конфиденциальности
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="px-3">
                        <div id="toc">
                        </div>
                        <br>
                        <vue-markdown class="site-markdown"
                                      style="max-width: 800px; text-align: justify;"
                                      :source="secpol_src"
                                      :toc="true" toc-id="toc"
                                      :toc-anchor-link="false"
                                      toc-class="toc-ul"
                                      :html="true" :typographer="true"
                                      :emoji="false" :breaks="true">
                        </vue-markdown>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import $ from 'jquery';
    import VueMarkdown from 'vue-markdown'
    export default {
        name: "Policy",
        data() {
            return {
                secpol_src: ''
            }
        },
        components: {
            VueMarkdown,
        },
        created() {
            this.load_texts();
        },
        methods: {
            // Texts
            load_texts() {
                $.ajax({
                    url: '/content/documents/secpol.txt',
                    type: 'GET',
                    data: {},
                    success: (response) => {
                        this.secpol_src = 'Source for secpol.txt not found.';
                        if (typeof response === 'string' && response.length > 0)
                            if (response.search('<!DOCTYPE html>') === -1)
                                this.secpol_src = response;
                    },
                    error: () => {
                        this.secpol_src = 'Source for secpol.txt not found.';
                    },
                });
            },
        }
    }
</script>

<style scoped>
</style>